import { render, staticRenderFns } from "./uni.vue?vue&type=template&id=ae4df796&scoped=true&"
import script from "./uni.vue?vue&type=script&lang=js&"
export * from "./uni.vue?vue&type=script&lang=js&"
import style0 from "./uni.vue?vue&type=style&index=0&id=ae4df796&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae4df796",
  null
  
)

export default component.exports